module.exports = __webpack_public_path__ + "img/library.7cb9528d.svg";